document.addEventListener('DOMContentLoaded',function(){

    const $banner = document.querySelectorAll('.card-carrossel');

    if(!$banner.length) return

    jQuery('.card-carrossel').slick({
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2200,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: jQuery('.prev'),
        nextArrow: jQuery('.next'),
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    });
})